(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const badgeSelector = '.cs-rider-height[data-dynamic-option-position]';

    const updateBadge = (badge) => {
      const section = badge.closest('.cs-product-main-section');
      const label = badge.querySelector('.cs-rider-height__text');
      const description = badge.querySelector('.cs-rider-height__description');
      if (!section || !label) return;

      const position = badge.dataset.dynamicOptionPosition;
      const selectedOption = section.querySelector(
        `.product_accessory_sku.accessory_sku_active[data-position="${position}"]`
      );
      const selectedValue = selectedOption?.dataset.value || '';
      const nextText = selectedValue === badge.dataset.dynamicOptionValue
        ? badge.dataset.alternateText
        : badge.dataset.defaultText;
      const nextDescription = selectedValue === badge.dataset.dynamicOptionValue
        ? badge.dataset.alternateDescription
        : badge.dataset.defaultDescription;
      if (label.textContent !== nextText) label.textContent = nextText;
      if (description && description.textContent !== nextDescription) description.textContent = nextDescription;
    };

    const initializeBadges = (root = document) => {
      root.querySelectorAll(badgeSelector).forEach(updateBadge);
    };

    if (window.macfoxRiderHeightBadgeInitialized) {
      initializeBadges();
      return;
    }
    window.macfoxRiderHeightBadgeInitialized = true;

    document.addEventListener('click', (event) => {
      const option = event.target.closest('.product_accessory_sku[data-position]');
      if (!option) return;

      const section = option.closest('.cs-product-main-section');
      const badge = section?.querySelector(badgeSelector);
      if (!badge || option.dataset.position !== badge.dataset.dynamicOptionPosition) return;

      queueMicrotask(() => updateBadge(badge));
    });

    document.addEventListener('shopify:section:load', (event) => initializeBadges(event.target));
    initializeBadges();
  })();

  } catch(e) { console.error(e); }
})();
})();
